import Reveal from "./Reveal";

const MILESTONES = [
  { year: "2000", text: "Yojna Jaisingh begins her journey in the furniture industry — learning design, materials, manufacturing and the art of listening to clients." },
  { year: "2013", text: "Jaipur Furniture is founded with a single vision: fully customized, handcrafted furniture where craftsmanship is never compromised." },
  { year: "2014–19", text: "Manufacturing capabilities expand. A loyal clientele grows across Jaipur and beyond — one satisfied home leading to another." },
  { year: "2020–23", text: "Larger residential, hospitality and commercial projects. Customization deepens; the workshop becomes a factory of our own." },
  { year: "Today", text: "Continuing to innovate and deliver premium handcrafted furniture to clients across India — with a new factory and a new brand on the horizon." },
];

export default function Journey() {
  return (
    <section id="journey" data-testid="journey-section" className="bg-cream py-28 md:py-40 relative overflow-hidden">
      <span className="absolute -left-8 top-10 font-display text-outline-oxblood text-[26vw] leading-none select-none pointer-events-none" aria-hidden>
        13
      </span>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 relative">
        <Reveal>
          <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">The Journey</p>
          <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight max-w-3xl">
            Two decades of patience, <em className="text-oxblood font-light">one uncompromising standard.</em>
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28 relative">
          <span className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px bg-oxblood/25" aria-hidden />
          {MILESTONES.map((m, i) => (
            <Reveal key={m.year} delay={i * 0.05}>
              <div
                data-testid={`journey-milestone-${i}`}
                className={`relative grid md:grid-cols-2 gap-4 md:gap-16 pb-16 md:pb-24 pl-10 md:pl-0 ${i % 2 ? "" : ""}`}
              >
                <span className="absolute left-0 md:left-1/2 top-2 -translate-x-0 md:-translate-x-1/2 w-[15px] h-[15px] rounded-full border-2 border-brass bg-cream" aria-hidden />
                <div className={i % 2 ? "md:order-2 md:text-left md:pl-16" : "md:text-right md:pr-16"}>
                  <span className="font-display text-5xl md:text-7xl text-oxblood">{m.year}</span>
                </div>
                <p className={`text-ink/70 font-light leading-relaxed text-base max-w-md ${i % 2 ? "md:order-1 md:text-right md:pr-16 md:justify-self-end" : "md:pl-16"}`}>
                  {m.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
